import React, { Component } from 'react';
import ActionEditorContainer from '../ActionEditorContainer';
import ActionDiscordEditorComponent from './ActionDiscordEditorComponent';

class ActionDiscordEditorContainer extends Component {
  public render() {
    return <ActionEditorContainer editor={<ActionDiscordEditorComponent />} type='discord' icon='discord' />;
  }
}

export default ActionDiscordEditorContainer;
